import { useGetProperties } from "@/hooks/main-hook";
import { useStore } from "@/state-management/context";
import { useSearchParams } from "next/navigation";
import { useMemo, useState } from "react";
import UnitsLayout from "../layout/UnitsLayout";
import SaveSearchButton from "./SaveSearchButton";

export default function PropertiesData() {
  const { filter } = useStore();
  const [currentPage, setCurrentPage] = useState(1);

  const searchParams = useSearchParams();

  const type = searchParams.get("type");
  const location = searchParams.get("location");

  const area = searchParams.get("area");
  const tab = searchParams.get("tab");

  const query = useMemo(() => {
    return {
      page: currentPage,
      limit: 20,
      type: type ? type : filter?.propertyType?.filter(Boolean)?.join(","),
      location: location
        ? location
        : filter?.location?.filter(Boolean)?.join(","),
      area,
      tab: tab ? tab : filter.type,
      priceOrder: filter.priceOrder,
      min: filter?.price?.min,
      max: filter?.price?.max,
    };
  }, [currentPage, type, location, area, tab, filter]);
  const { data, isLoading } = useGetProperties(query);

  return (
    <div className="w-full">
      <div className="flex justify-end mb-4">
        <SaveSearchButton />
      </div>
      <UnitsLayout
        data={data}
        isLoading={isLoading}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
      />
    </div>
  );
}
